import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Preview(selectedItems: any[], setIsCMFilePreviewPanelOpen: (isCMFilePreviewPanelOpen: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);
    
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
       
    const [menuItem_Preview, setMenuItem_Preview] = React.useState<IContextualMenuItem>();
    const [menuItem_Preview_IconOnly, setMenuItem_Preview_IconOnly] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        setMenuItem_Preview_IconOnly(
            {
                key: "preview",
                disabled: selectedItems?.length !== 1 || selectedItems[0].ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) || currentDirectory.type === ComponentTypes.SharePointList,
                iconProps: { iconName: "PreviewLink" },
                iconOnly: true,
                tooltipHostProps: {
                  content: <span>Preview</span>
                },
                onClick: () => {
                  setIsCMFilePreviewPanelOpen(true);
                }
            }
        )

        if (selectedItems?.length === 1 && !selectedItems[0].ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && currentDirectory.type !== ComponentTypes.SharePointList) {
            setMenuItem_Preview(
                {
                    key: 'preview',
                    name: languageStrings.ShowPreview,
                    iconProps: { iconName: "PreviewLink" },
                    onClick: () => {
                        setIsCMFilePreviewPanelOpen(true);
                    }
                }
            )
        } else {
            setMenuItem_Preview(null)
            setMenuItem_Preview_IconOnly(null)
        }
    }, [selectedItems])
    
    return {
        menuItem_Preview,
        menuItem_Preview_IconOnly
    }

}